import React from 'react';
import PropTypes from 'prop-types';
import { fieldInputPropTypes, fieldMetaPropTypes } from 'redux-form';
import { FormGroup, FormLabel, FormError, Input as FormInput } from './styled';
import isFalsy from '../../utils/services/isFalsy';

const Input = ({
  input,
  meta: { asyncValidating, submitFailed, error, active },
  placeholder,
  label,
  isLoading,
  margin,
  ...props
}) => (
  <FormGroup
    isActive={active}
    hasValue={!isFalsy(input.value, { allowZero: true })}
    isLoading={isLoading || asyncValidating}
    margin={margin}
  >
    {!!label && <FormLabel>{label}</FormLabel>}
    <FormInput {...input} placeholder={placeholder} {...props} />

    {submitFailed && error && <FormError>{error}</FormError>}
  </FormGroup>
);

Input.propTypes = {
  input: PropTypes.shape(fieldInputPropTypes).isRequired,
  meta: PropTypes.shape(fieldMetaPropTypes).isRequired,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  isLoading: PropTypes.bool,
  margin: PropTypes.string,
};

Input.defaultProps = {
  placeholder: undefined,
  label: undefined,
  isLoading: false,
  margin: undefined,
};

export default Input;
